module.exports = __webpack_public_path__ + "img/link1.3578babf.png";